import { render, staticRenderFns } from "./DiagramTopBar.vue?vue&type=template&id=ae8ae9d2&"
import script from "./DiagramTopBar.vue?vue&type=script&lang=js&"
export * from "./DiagramTopBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports